export default {"src":"/_next/static/media/coin-group.6cbed365.svg","height":90,"width":114,"blurWidth":0,"blurHeight":0};